<template>
  <div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          :label="label"
          prepend-inner-icon="mdi-calendar"
          readonly
          filled
          v-bind="attrs"
          v-on="on"
          :hide-details="hideDetails"
          :rules="rules"
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        :no-title="noTitle"
        scrollable
        show-adjacent-months
        show-week
        color="primary"
        header-color="date"
        first-day-of-week="1"
        :max="max"
        :min="min"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(date)">
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      required: true,
    },
    hideDetails: {
      default: "auto",
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noTitle: {
      type: Boolean,
      default: true,
    },
    rules: {
      default() {
        return [];
      },
    },
    max: {
      default: null,
    },
    min: {
      default: null,
    },
  },
  data: () => ({
    modal: false,
  }),
  computed: {
    // date: {
    //   get() {
    //     return this.value
    //       ? moment(this.value).format("YYYY-MM-DD")
    //       : this.value;
    //   },
    //   set(value) {
    //     this.$emit("input", value);
    //   },
    // },
    date: {
      get: function () {
        if (this.value) {
          return moment(this.value).format("YYYY-MM-DD");
        }
        return this.value;
      },
      set: function (value) {
        //Convert from YYYY-MM-DD to 2001-02-08T00:00:00+01:00
        var data = value;
        if (value) {
          data = moment(value).format();
        }
        this.$emit("input", data);
      },
    },
    // dateFormatted() {
    //   return this.value ? moment(this.value).format("DD.MM.YYYY") : this.value;
    // },
    dateFormatted: {
      get() {
        if (this.date) {
          return moment(this.date).format("DD.MM.YYYY");
        }
        return this.date;
      },
      set(value) {
        this.data = value;
      },
    },
  },
};
</script>
